module.exports = __webpack_public_path__ + "static/assets/34a9cc06bd425a63ea3a49987b63866b.svg";